var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" Welcome to the help section, here you can find detailed help for a variety of functions within the MeaVitae app. ")])])}]

export { render, staticRenderFns }